import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { Resolution } from './shared'
import { BugtrackerRequest } from '../../bugtrackers/api/shared'
import { getResolutions, GetResolutionsArgs } from './requests/get-resolutions'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseResolutionsQueryProps {
  organizationUuid: string
  bugtrackerRequest: BugtrackerRequest | null
  enabled?: boolean
}

export interface ResolutionsQueryResponse {
  resolutions: Resolution[] | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseResolutionsQuery = (
  props: UseResolutionsQueryProps
) => ResolutionsQueryResponse

// TODO - don't delete, this one will be used soon
export const useResolutionsQuery: UseResolutionsQuery = ({
  organizationUuid,
  bugtrackerRequest,
  enabled = true
}: UseResolutionsQueryProps) => {
  const {
    data: resolutions,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetResolutionsArgs, Resolution[]>(
    [Query.INTEGRATIONS_RESOLUTIONS_JIRA, organizationUuid],
    getResolutions,
    {
      organizationUuid,
      bugtrackerRequest
    },
    {
      enabled: !!bugtrackerRequest && enabled
    }
  )

  return {
    resolutions,
    error,
    isError,
    isLoading
  }
}
